import e, { useRef as t, useEffect as n, useState as r, useCallback as o, useLayoutEffect as i, createContext as c, useContext as a, Fragment as u } from "react";
import { createPortal as s } from "react-dom";

function l(e) {
  return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function f(e, t) {
  return (f = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function d() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

function v(e, t, n) {
  return (v = d() ? Reflect.construct : function (e, t, n) {
    var r = [null];
    r.push.apply(r, t);
    var o = new (Function.bind.apply(e, r))();
    return n && f(o, n.prototype), o;
  }).apply(null, arguments);
}

function p(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return (p = function p(e) {
    if (null === e || -1 === Function.toString.call(e).indexOf("[native code]")) return e;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, n);
    }

    function n() {
      return v(e, arguments, l(this).constructor);
    }

    return n.prototype = Object.create(e.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), f(n, e);
  })(e);
}

function h(e) {
  var t = e.baseUrl,
      n = void 0 === t ? process.env.SITE_NAV_URL : t,
      r = e.siteSlug,
      o = e.variant,
      i = e.content,
      c = void 0 === i ? "prod" : i;
  if (!n) throw new Error("Missing either baseUrl prop or `SITE_NAV_URL` environment variable");
  n.endsWith("/") || (n += "/");
  var a = "qa" === c ? "-qakldsjf" : "",
      u = n + "fallback.html";
  return r ? {
    src: "" + n + r + "/" + (o ? "v1-" + o + a : "v1" + a) + ".html",
    alt: u
  } : {
    src: u,
    alt: u
  };
}

var m = function m(e, t) {
  var n = void 0 === t ? {} : t,
      r = n.forceDotCom,
      o = n.variant,
      i = void 0 === o ? r ? "dotcom" : void 0 : o,
      c = n.baseUrl,
      a = void 0 === c ? process.env.SITE_NAV_URL : c,
      u = n.content;

  try {
    var s,
        l = function l(e) {
      function t(e) {
        return {
          esi: !1,
          baseUrl: a,
          forceDotCom: r,
          html: f,
          siteSlug: d
        };
      }

      var n = function () {
        if (s) return Promise.resolve(s(p || m)).then(function (e) {
          if (!e.ok) throw new g("Failed to fetch Site Nav", e);
          return Promise.resolve(e.text()).then(function (e) {
            f = e;
          });
        });
      }();

      return n && n.then ? n.then(t) : t();
    },
        f = "",
        d = w(e),
        v = h({
      siteSlug: d,
      baseUrl: a,
      variant: i,
      content: u
    }),
        p = v.src,
        m = v.alt,
        y = function () {
      if ("undefined" == typeof fetch) return function () {
        if ("undefined" == typeof window) return Promise.resolve(import("node-fetch")).then(function (e) {
          s = e.default;
        });
        throw new Error("Please include a fetch polyfill");
      }();
      s = fetch;
    }();

    return Promise.resolve(y && y.then ? y.then(l) : l());
  } catch (e) {
    return Promise.reject(e);
  }
},
    g = function (e) {
  var t, n;

  function r(t, n) {
    var o;
    return (o = e.call(this, t + " (" + n.status + " @ " + n.url + ")") || this).name = "SiteNavError", o.status = n.status, o.url = n.url, Object.setPrototypeOf(function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(o), r.prototype), o;
  }

  return n = e, (t = r).prototype = Object.create(n.prototype), t.prototype.constructor = t, t.__proto__ = n, r;
}(p(Error)),
    y = /^[a-zA-Z][a-zA-Z-]*[a-zA-Z]$/;

function w(e) {
  var t,
      n = e;

  if (n && n.startsWith("/")) {
    var r = n.split("/");
    r.length > 1 && (n = r[1]);
  }

  return function (e) {
    return !!e && y.test(e);
  }(n) || console.warn("Invalid site slug: " + n), null === (t = n) || void 0 === t ? void 0 : t.toLowerCase();
}

var b = function b(r) {
  var o,
      i = r.html,
      c = r.siteSlug,
      a = r.variant,
      u = void 0 === a ? r.forceDotCom ? "dotcom" : void 0 : a,
      s = r.esi,
      l = void 0 === s ? "undefined" == typeof window && "production" === process.env.NODE_ENV : s,
      f = r.baseUrl,
      d = void 0 === f ? process.env.SITE_NAV_URL : f,
      v = r.content,
      p = void 0 === v ? "prod" : v,
      m = (function (e, t) {
    if (null == e) return {};
    var n,
        r,
        o = {},
        i = Object.keys(e);

    for (r = 0; r < i.length; r++) {
      t.indexOf(n = i[r]) >= 0 || (o[n] = e[n]);
    }
  }(r, ["html", "siteSlug", "forceDotCom", "variant", "esi", "baseUrl", "content"]), t(null));
  if (n(function () {
    if (!l && i) {
      var e,
          t = document.getElementById("site-nav-embed");
      if (!t && (null === (e = t = m.current) || void 0 === e ? void 0 : e.innerHTML.trim())) return;

      if (t && "true" !== t.dataset.siteNavInjected) {
        var n = document.createRange();
        n.setStart(t, 0), t.appendChild(n.createContextualFragment(i)), t.dataset.siteNavInjected = "true";
      }
    }
  }, [l, i]), "undefined" == typeof window) if (l && !i) {
    var g = h({
      siteSlug: w(c),
      baseUrl: d,
      variant: u,
      content: p
    });
    o = '<esi:include src="' + g.src + '" alt="' + g.alt + '" onerror="continue" />';
  } else o = i;
  return e.createElement("div", {
    "data-site-nav-esi": l && !i,
    ref: m,
    suppressHydrationWarning: !0,
    dangerouslySetInnerHTML: {
      __html: o || ""
    }
  });
},
    S = "undefined" != typeof window ? i : n;

function O() {
  var e,
      t,
      i,
      c = (t = (e = r(null))[0], i = e[1], S(function () {
    var e = document.getElementById("vcc-site-nav");
    if (e) i(e);else if ("undefined" != typeof MutationObserver) {
      var t = new MutationObserver(function () {
        var e = document.getElementById("vcc-site-nav");
        e && (t.disconnect(), i(e));
      });
      return t.observe(document.body, {
        childList: !0,
        subtree: !0
      }), function () {
        return t.disconnect();
      };
    }
  }, []), t),
      a = r(0),
      u = a[0],
      s = a[1],
      l = r(!0),
      f = l[0],
      d = l[1],
      v = o(function () {
    c && s(c.clientHeight);
  }, [c]);
  return S(function () {
    return v();
  }, [v]), n(function () {
    if (c && "undefined" != typeof ResizeObserver) {
      var e = new ResizeObserver(v);
      return e.observe(c), function () {
        return e.disconnect();
      };
    }
  }, [c, v]), n(function () {
    if (c) {
      var e = function e(_e) {
        d("visible" === _e.detail);
      };

      return c.addEventListener("sitenav:visibilitychange", e), function () {
        c.removeEventListener("sitenav:visibilitychange", e);
      };
    }
  }, [c]), f ? u : 0;
}

var E = function E(e, t) {
  void 0 === t && (t = {});
  var o = t.forceDotCom,
      i = t.baseUrl,
      c = t.content,
      a = w(e),
      u = r({
    baseUrl: i,
    siteSlug: a,
    forceDotCom: o,
    html: "",
    content: c
  }),
      s = u[0],
      l = u[1];
  return n(function () {
    "production" !== process.env.NODE_ENV && m(e, {
      baseUrl: i,
      forceDotCom: o,
      content: c
    }).then(function (e) {
      return l(e);
    });
  }, [e, o, i, c]), s;
},
    N = {
  componentUpdater: null,
  hideOnScroll: "mobile",
  smoothHideOnScrollOnDesktop: !1,
  onRender: null
},
    _ = function _(t) {
  var r = t.children,
      o = t.hideOnScroll,
      i = void 0 === o ? "mobile" : o,
      c = t.smoothHideOnScrollOnDesktop,
      a = void 0 !== c && c;
  return n(function () {
    P.options({
      hideOnScroll: i,
      smoothHideOnScrollOnDesktop: a
    });
  }, [i, a]), e.createElement(e.Fragment, null, r);
},
    P = new (function () {
  function e() {
    "undefined" != typeof window && (window.siteNavigationService || (window.siteNavigationService = N));
  }

  var t = e.prototype;
  return t.addStateListener = function (e) {
    this.setSiteNavigationProp("onRender", e);
  }, t.options = function (e) {
    var t, n;
    this.setSiteNavigationProp("hideOnScroll", null !== (t = null == e ? void 0 : e.hideOnScroll) && void 0 !== t ? t : this.getSiteNavigationProp("hideOnScroll")), this.setSiteNavigationProp("smoothHideOnScrollOnDesktop", null !== (n = null == e ? void 0 : e.smoothHideOnScrollOnDesktop) && void 0 !== n ? n : this.getSiteNavigationProp("smoothHideOnScrollOnDesktop"));
  }, t.setSiteNavigationProp = function (e, t) {
    "undefined" != typeof window && (window.siteNavigationService[e] = t);
  }, t.getSiteNavigationProp = function (e) {
    return "undefined" != typeof window ? window.siteNavigationService[e] : null;
  }, e;
}())(),
    D = {
  topbarHeight: 0,
  sideNavIsOpen: !1,
  desktopCarsMenuIsOpen: !1,
  toggleSideNav: function toggleSideNav() {},
  toggleDesktopCarsMenu: function toggleDesktopCarsMenu() {}
},
    U = c(D),
    I = function I(t, o) {
  return function (i) {
    var c = r(D),
        a = c[0],
        u = c[1];
    return n(function () {
      P.addStateListener(function (e) {
        u(e);
      });
    }, []), e.createElement(_, Object.assign({}, o), e.createElement(U.Provider, {
      value: a
    }, e.createElement(t, Object.assign({}, i))));
  };
},
    R = function R() {
  return a(U);
},
    j = "undefined" != typeof window ? i : n,
    L = function L(t) {
  var n = t.children,
      o = t.Spacer,
      i = r(null),
      c = i[0],
      a = i[1];
  j(function () {
    if (window.siteNavigationService.componentUpdater) {
      var e = document.getElementById("site-nav-topbar-wrapper");
      a(e);
    } else var t = setInterval(function () {
      if (window.siteNavigationService.componentUpdater) {
        var e = document.getElementById("site-nav-topbar-wrapper");
        a(e), clearInterval(t);
      }
    }, 50);
  }, []);
  var l = "function" == typeof n ? c ? s(n(c), c) : n(c) : c ? s(n, c) : n;
  return e.createElement(u, null, l, o ? c && o : null);
};

export { L as FollowTopbar, b as SiteNavigationEmbed, m as fetchSiteNavigationProps, E as useSiteNavigationProps, R as useSiteNavigationServiceState, O as useTopbarHeight, I as withSiteNavigationService };